import React from 'react';
import moment from 'moment';

import {
  DatePickerField,
  SearchTextField,
  MCButton,
  View,
  SelectField
} from 'src/components/basic';
import { popupModel, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import ShortInfo from 'src/components/user/ShortInfo';
import AlertManager from 'src/components/alert';

import { BASE_ICONS } from 'src/components/svg';

import {
  withRouter,
  remCss,
  number,
  lang,
  upperFirstChar,
  permissions,
  objectToSelectList
} from 'src/helpers';

import model from './model';
import DetailInvoice from './DetailInvoice';
import constants from 'src/constants';
import LANG_CONST from 'src/helpers/lang/const';

class Invoices extends BaseComponent {
  componentDidMount() {
    model.setStateSilent({ pageIndex: 0 });
    model.subscribe(this.subscription);

    let invoiceId =
      this.props.router.location.state?.invoiceId || this.props.router.params.invoiceId;

    if (invoiceId) {
      popupModel.setActivePopup('invoice_detail', {
        active: true,
        component: DetailInvoice,
        props: {
          item: { id: this.props.router.location.state?.invoiceId }
        }
      });
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  prevWeek = () => {
    let startDate = model.input('startDate').clone();
    let newStartDate = startDate.clone().startOf('isoWeek').subtract(1, 'week');
    let newEndDate = newStartDate.clone().add('1', 'week');
    model.setStateSilent({ startDate: newStartDate, endDate: newEndDate, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  nextWeek = () => {
    let endDate = model.input('endDate').clone();
    let newStartDate = endDate.startOf('isoWeek');
    let newEndDate = newStartDate.clone().add(1, 'week');
    model.setStateSilent({ startDate: newStartDate, endDate: newEndDate, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  onSearchChange = (key, value) => {
    if (value?.toString() === model.input(key)?.toString()) return;
    model.setStateSilent({ [key]: value, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  returnActions = (item) => {
    const medium = !this.props.screenDetail?.isLargeScreen;

    return (
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1 }}>
          {medium &&
            item?.invoiceDate &&
            moment(item.invoiceDate, 'YYYYMMDD').format(
              `[${lang.t(LANG_CONST.date)}: ]DD - MMM - YYYY`
            )}
        </View>
        <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
          {item.status === constants.general.invoiceStatus.paid && (
            <MCButton
              onClick={() => {
                AlertManager.popup(AlertManager.TYPES.WARN, {
                  close: false,
                  maxWidth: 500,
                  title: LANG_CONST.notice.refund_invoice,
                  cancelButton: {
                    label: LANG_CONST.buttons.cancel,
                    action: (actions) => actions.hide()
                  },
                  actionButton: {
                    label: LANG_CONST.buttons.confirm_refund,
                    action: (actions) => {
                      actions.setLoading(true);
                      model.refund(item, (err) => {
                        actions.hide();
                        actions.setLoading(false);
                        if (err) {
                          AlertManager.popup(AlertManager.TYPES.WARN, {
                            close: false,
                            title: err,
                            cancelButton: {
                              label: LANG_CONST.buttons.close,
                              action: (actions) => actions.hide()
                            }
                          });
                        }
                      });
                    }
                  }
                });
              }}
              primary
              light
              padding={5}
              radius
              fillOpacity={'0.5'}
              label={LANG_CONST.buttons.refund}
            />
          )}
          <MCButton
            onClick={() => {
              popupModel.setActivePopup('invoice_detail', {
                active: true,
                component: DetailInvoice,
                props: {
                  item
                }
              });
            }}
            // iconname={BASE_ICONS.EYE_FILL}
            label={LANG_CONST.buttons.view}
            style={{ opacity: 0.5 }}
            width={42}
            dark
            padding={5}
            radius
            fillOpacity={'0.5'}
          />
          <MCButton
            type={'button'}
            onClick={() => model.openPdf(item)}
            iconname={BASE_ICONS.DOWNLOAD2}
            // iconname={'download-icon'}
            // fillOpacity={'0.5'}
            padding={0}
            // viewSize={42}
            width={42}
            dark
            radius
          />
        </div>
      </View>
    );
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    const medium = !this.props.screenDetail?.isLargeScreen;

    const columns = [
      {
        label: LANG_CONST.serie_invoice,
        resize: true,
        width: `${remCss(160)}px`,
        renderCell: (item) => item.serieInvoiceNo
      },
      {
        label: LANG_CONST.patients,
        resize: true,
        renderCell: (item) => {
          const partner = item.patient;
          return (
            partner && (
              <ShortInfo
                user={partner}
                to={permissions.profilePath(partner)}
                specialist={[]}
                vertical
              />
            )
          );
        }
      },

      !medium && {
        label: LANG_CONST.date,
        resize: true,
        renderCell: (item) => {
          if (!item?.invoiceDate) {
            return null;
          }
          let date = moment(item.invoiceDate, 'YYYYMMDD');
          return date.format('DD - MMM - YYYY');
        }
      },
      {
        label: LANG_CONST.doctors,
        resize: true,
        renderCell: (item) => {
          const partner = item.doctor;
          return (
            partner && <ShortInfo user={partner} to={permissions.profilePath(partner)} vertical />
          );
        }
      },
      {
        label: LANG_CONST.clinics,
        resize: true,
        renderCell: (item) => {
          const partner = item.clinic?.id ? item.clinic : null;
          return (
            partner && <ShortInfo user={partner} to={permissions.profilePath(partner)} vertical />
          );
        }
      },
      {
        label: LANG_CONST.status,
        resize: true,
        width: `${remCss(120)}px`,
        renderCell: (item) => (
          <button className={'mc-status-' + item.status}>{upperFirstChar(item.status)}</button>
        )
      },
      {
        label: LANG_CONST.amount,
        resize: true,
        width: `${remCss(160)}px`,
        renderCell: (item) => `${number.format(item.amount || 0)} ${item.currency}`
      },
      !medium && {
        label: LANG_CONST.actions,
        width: `${remCss(245)}px`,
        cellStyles: { textAlign: 'end' },
        renderCell: this.returnActions
      }
    ];

    return (
      <div className={'mc-container-content mc-appointment'}>
        <div className={'mc-container-content__header mc-flex-20'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.invoices)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />

          <SelectField
            width={remCss(150)}
            isClearable={false}
            template={'6'}
            options={[
              { value: 'all', label: lang.t(LANG_CONST.all) },
              ...objectToSelectList(LANG_CONST.constants.invoice_status)
            ]}
            name={'status'}
            placeholder={'Health'}
            value={model.input('status')}
            onChange={(n, v) => {
              if (v.toString() === model.input('status').toString()) return;
              model.setStateSilent({
                pageIndex: 0,
                status: v
              });
              model.setListState({ items: [], total: 0 }, model.getCurrentId(), null, true);
              model.refresh();
            }}
          />
          <div className={'mc-flex-10'}>
            <MCButton
              label={'<'}
              // small
              radius
              primary
              dark
              onClick={this.prevWeek}
            />
            <DatePickerField
              style={{ minWidth: remCss(200) }}
              template={6}
              icontype={2}
              close={false}
              noIcon={true}
              format='D MMM YYYY'
              placeholder={'Start Date'}
              placement={'bottom-center'}
              name={'startDate'}
              value={model.state.startDate}
              onChange={this.onSearchChange}
              invalid={{}}
            />
            <DatePickerField
              style={{ minWidth: remCss(200) }}
              template={6}
              icontype={2}
              close={false}
              noIcon={true}
              format='D MMM YYYY'
              placeholder={'End Date'}
              placement={'bottom-center'}
              name={'endDate'}
              value={model.state.endDate}
              onChange={this.onSearchChange}
              invalid={{}}
            />
            <MCButton
              label={'>'}
              // small
              radius
              primary
              dark
              onClick={this.nextWeek}
            />
          </div>
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              loading={loading}
              data={items}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              columns={columns.filter((c) => !!c)}
              total={total}
              limit={model.listLimit}
              noResults={noResults}
              searchQuery={searchQuery}
              key={medium ? 1 : 0}
              className={medium ? 'mc-row2' : ''}
              renderExtend={medium && this.returnActions}
              otherProps={{ cell: () => ({ style: { alignItems: 'flex-start' } }) }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Invoices);
